import { useGateValue } from '@statsig/react-bindings'

import {
   APPLICATION_MANAGEMENT_GATE,
   ENABLE_FEE_ENGINE_LOGS_GATE,
   FILE_TRANSFER_GATE,
   NEW_USER_NEW_OFFICER_GATE,
   PMU_APPLICATION_ACTIONS_GATE,
   PMU_PORTAL_GATE,
   RELIEVE_AND_DISTRIBUTE_GATE,
   REPLACE_OFFICER_GATE,
   RETURN_FROM_LEAVE_GATE,
   SHORTFALL_COUNTER_DECREMENT_GATE
} from '../constants/FeatureGatesConstants'

const useGetFeatureGates = () => {
   const isApplicationManagementGateEnabled = useGateValue(
      APPLICATION_MANAGEMENT_GATE
   )
   const isPMUPortalGateEnabled = useGateValue(PMU_PORTAL_GATE)
   const isPMUApplicationActionsEnabled = useGateValue(
      PMU_APPLICATION_ACTIONS_GATE
   )
   const isRelieveAndDistributeEnabled = useGateValue(
      RELIEVE_AND_DISTRIBUTE_GATE
   )
   const isReplaceOfficerEnabled = useGateValue(REPLACE_OFFICER_GATE)
   const isReturnFromLeaveEnabled = useGateValue(RETURN_FROM_LEAVE_GATE)
   const isNewUserNewOfficerEnabled = useGateValue(NEW_USER_NEW_OFFICER_GATE)
   const isFeeEngineLogsEnabled = useGateValue(ENABLE_FEE_ENGINE_LOGS_GATE)
   const isFileTransferEnabled = useGateValue(FILE_TRANSFER_GATE)
   const isShortfallCounterDecrementEnabled = useGateValue(
      SHORTFALL_COUNTER_DECREMENT_GATE
   )

   return {
      isApplicationManagementGateEnabled,
      isPMUPortalGateEnabled,
      isPMUApplicationActionsEnabled,
      isRelieveAndDistributeEnabled,
      isReplaceOfficerEnabled,
      isReturnFromLeaveEnabled,
      isNewUserNewOfficerEnabled,
      isFeeEngineLogsEnabled,
      isFileTransferEnabled: true,
      isShortfallCounterDecrementEnabled
   }
}

export default useGetFeatureGates
